// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Naa-z","narrowOptionButtons":"Oaa-z","noOptions":"Paa-z"};